// extracted by mini-css-extract-plugin
export default {"closeButton":"TeamAddMembersDialog_closeButton__q8xRf","endSelect":"TeamAddMembersDialog_endSelect__uZtIR","scrollBox":"TeamAddMembersDialog_scrollBox__clitA"};